function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { MDCTextInput, MDCFileUpload } from '../../../jsx/components/mdc-components';
import { AlertMessage } from '../../ui/alert';
import ProgressSuccess from '../../ui/progress/success';
import endpoints from "../../endpoints";
import account from "../../data/account";
import Auth from "../../functions/authenticate";
import Locations from "./locations";
import ServiceFactory from "../../service";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "initServices", () => {
      var Service = ServiceFactory.getType('/company-analysis', 'research');
      this.Service = new Service();
    });
    _defineProperty(this, "onCompanyChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        company: value
      });
    });
    _defineProperty(this, "onUrlChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        url: value
      });
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onLocationChange", (prop, value, index) => {
      let state = this.state;
      let locations = state.locations;
      let location = locations.find(obj => obj.index === index);
      location[prop] = value;
      this.setState({
        locations
      });
    });
    _defineProperty(this, "onLocationRemove", index => {
      let arr = this.state.locations;
      const locations = arr.filter(obj => obj.index !== index);
      this.setState({
        locations
      });
    });
    _defineProperty(this, "onLocationAdd", () => {
      let arr = this.state.locations;
      let maxIndex = Math.max(...arr.map(obj => obj.index));
      maxIndex += 1;
      arr.push({
        city: '',
        state: '',
        country: 'United States',
        index: maxIndex
      });
      this.setState({
        locations: arr
      });
    });
    _defineProperty(this, "onViewClick", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onCreate", event => {
      let state = this.state;
      let message = null;
      let messageType = null;
      let showMessage = false;
      if (!state.company) {
        showMessage = true;
        messageType = 'error';
        message = 'Company Required...';
      }
      if (!state.url) {
        showMessage = true;
        messageType = 'error';
        message = 'Company URL Required...';
      }
      let arr = state.locations;
      let locations = [];
      arr.forEach(obj => {
        if (!obj.city || !obj.state || !obj.country) {
          showMessage = true;
          messageType = 'error';
          message = 'Submitted Location Fields Required...';
        }
        let item = `${obj.city}, ${obj.state}, ${obj.country}`;
        locations.push(item);
      });
      if (showMessage) {
        this.setState({
          showMessage,
          messageType,
          message
        });
      } else {
        this.post(locations);
      }
    });
    _defineProperty(this, "post", locations => {
      let state = this.state;
      let model = {
        url: state.url,
        company: state.company,
        locations: locations,
        userId: state.userId
      };
      let message = null;
      let messageType = null;
      let showMessage = false;
      let showSuccess = true;
      this.Service.post(model, (err, data) => {
        if (!err) {
          this.setState({
            showMessage,
            messageType,
            message,
            showSuccess
          });
        } else {
          showSuccess = false;
          messageType = 'error';
          showMessage = true;
          message = 'Error submitting company analysis...';
          this.setState({
            showMessage,
            messageType,
            message,
            showSuccess
          });
        }
      });
    });
    this.state = this.initState();
  }
  initState() {
    var auth = Auth.get();
    var email = auth.email;
    return {
      company: '',
      url: '',
      locations: [{
        city: '',
        state: '',
        country: 'United States',
        index: 0
      }],
      showSuccess: false,
      showMessage: false,
      messageType: '',
      message: null,
      userId: email
    };
  }
  componentDidMount() {
    this.initServices();
    publishSearch('Research');
    publishEvent('reset-search', {});
  }
  render() {
    let state = this.state;
    return /*#__PURE__*/React.createElement(DetailContainer, {
      title: "New Company Analysis",
      onGoBack: this.onGoBack
    }, state.showSuccess ? /*#__PURE__*/React.createElement(ProgressSuccess, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium size-14"
    }, "Your company analysis has been successfully submitted.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: this.onViewClick
    }, "VIEW ANALYSES GRID")))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "1. Company"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Company Name",
      value: state.company,
      onChange: this.onCompanyChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "2. Domain/Url"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Company Domain",
      value: state.url,
      onChange: this.onUrlChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium fb-c"
    }, "3. Locations ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons grey-icon-pointer margin-left",
      onClick: this.onLocationAdd
    }, "add_circle_outline")), /*#__PURE__*/React.createElement("div", {
      className: "form-width-locations"
    }, /*#__PURE__*/React.createElement(Locations, {
      locations: state.locations,
      onChange: this.onLocationChange,
      onRemove: this.onLocationRemove,
      onAdd: this.onLocationAdd
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onCreate
    }, "Create Analysis")), this.state.showMessage && /*#__PURE__*/React.createElement(AlertMessage, {
      message: state.message,
      cls: state.messageType
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}
export class CompanyAnalysisCreateViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  render() {
    if (!this.allowRender) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  CompanyAnalysisCreateViewComponent
};